import { useTranslation } from 'react-i18next'
import React from 'react'

import IconText from '../../../../../packages/kiti/components/presentation/IconText'
import { useIntegrationList } from '../../_load/IntegrationsLoader'
import LogoText from '../../../../../packages/kiti/components/presentation/LogoText'
import { INTEGRATION_LOGO } from '../../../../fields/edit/_data/integrationLogos'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'

export const useQuestionTypeTooltip = () => {
  const { t } = useTranslation()

  const getTooltipDescription = questionTypeName => {
    return (
      t('fieldTypes.' + questionTypeName + '.description') || t('fieldTypes.' + questionTypeName) || questionTypeName
    )
  }

  return { getTooltipDescription }
}

const icons = {
  action_plan: 'RiDraftLine',
  block: 'RiStackLine',
  asset: 'RiToolsFill',
  checkbox: 'RiToggleLine',
  date: 'RiCalendarEventLine',
  datetime: 'RiAlarmLine',
  time: 'RiTimeLine',
  gallery: 'RiImageAddLine',
  pending: 'RiAlertLine',
  multiple: 'RiCheckboxMultipleLine',
  stock: 'RiArchiveLine',
  select: 'RiCheckboxCircleLine',
  sign: 'RiEdit2Line',
  address: 'RiCompass3Line',
  location: 'RiCompass3Line',
  numeric: 'RiCalculatorLine',
  integer: 'RiCalculatorLine',
  float: 'RiCalculatorLine',
  text: 'RiFileTextLine',
  place: 'RiMapPinLine',
  tags: 'RiListUnordered',
  informative: 'RiInformationLine',
  user: 'RiAccountBoxLine',
  calc: 'RiFunctions',
  integration: 'RiLinksFill',
  cpf_cnpj: 'BsCardHeading',
  coordinates: 'RiMapPin2Fill',
  file: 'RiFilePdfLine',
  validation_code: 'RiShieldCheckLine'
}

const QUESTIONS_TYPE_CAN_HAVE_LOGIC = ['checkbox', 'select', 'multiple', 'numeric', 'float', 'place', 'calc']

const QuestionTypeIconText = ({ question, questionType }) => {
  const { t } = useTranslation()
  const integrationList = useIntegrationList()

  const integrationPath = question?.data?.integration
  const hasIntegration = integrationList.includes(integrationPath?.integrationService)

  const canHaveLogic = QUESTIONS_TYPE_CAN_HAVE_LOGIC.includes(questionType.name)

  return (
    <>
      {hasIntegration ? (
        <LogoText
          label={integrationPath?.integrationFieldType}
          logoLeft={INTEGRATION_LOGO[integrationPath?.integrationService]}
        />
      ) : (
        <FlexGrid justify="space-between" align="center" gutter={0.3}>
          <FlexCol flex={1}>
            <IconText
              icon={icons[questionType.name] || 'RiSeparator'}
              left
              label={t('fieldTypes.' + questionType.name)}
              size="p"
              iconSize="1rem"
            />
          </FlexCol>
          {canHaveLogic && !question && (
            <FlexCol>
              <Icon name="BsToggles" size="1rem" color="primary" />
            </FlexCol>
          )}
        </FlexGrid>
      )}
    </>
  )
}

export default QuestionTypeIconText
